import cmpPackagesSearch from '../vue/PackagesSearch.vue';

window.PackagesSearch = (function(){
	const component = Vue.createApp(cmpPackagesSearch, {
		modelPackageSearch: window.modelPackageSearch // todo: put it on window.PackagesSearch (if that works)
	});
	delete window.modelPackageSearch; // todo: put it on window.PackagesSearch (if that works)
	return component.mount('#component-packages-search');
})();